import {
  useAudioNoteSavedNote,
  useIsAudioNoteSaving,
  useIsAudioNoteStarting,
  useIsRecordingAudioNote,
} from '@renderer/hooks/audio/use-audio-note-selectors'

export type AudioNotePhase = 'idle' | 'starting' | 'recording' | 'saving' | 'finished'

export function useAudioNotePhase(): AudioNotePhase {
  const isStarting = useIsAudioNoteStarting()
  const isRecording = useIsRecordingAudioNote()
  const isSaving = useIsAudioNoteSaving()
  const savedNote = useAudioNoteSavedNote()

  if (isStarting) {
    return 'starting'
  }
  if (isSaving) {
    return 'saving'
  }
  if (isRecording) {
    return 'recording'
  }
  if (savedNote) {
    return 'finished'
  }
  return 'idle'
}
